<!-- TEMPLATE -->
<template>
  <div :class="deanButtonClass">
    <button
      :class="deanButtonLinkClass"
      :disabled="disabled"
      @click="deanButtonClick()"
      :tabindex="tabindex"
    >
    <dean-icon
      v-if="icon"
      class="button-icon"
      :glyph="icon"
      :viewBox="icon.viewBox"
      height="20"
      width="20"
    >
    </dean-icon>
    <span :class="mobileCollapseClass">
      <slot></slot>
    </span>
    </button>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import deanIcon from './deanIcon.vue'

// COMPONENTS
@Component({
  components: {
    deanIcon
  }
})

export default class deanButton extends Vue {
  //PROPS
  @Prop() theme!: string;
  @Prop() icon!: object;
  @Prop({ default: false }) standard!: boolean;
  @Prop({ default: false }) success!: boolean;
  @Prop({ default: false }) info!: boolean;
  @Prop({ default: false }) warning!: boolean;
  @Prop({ default: false }) danger!: boolean;
  @Prop({ default: false }) primary!: boolean;
  @Prop({ default: false }) secondary!: boolean;
  @Prop({ default: false }) link!: boolean;
  @Prop({ default: false }) grey!: boolean;
  @Prop({ default: false }) groupButton!: boolean;
  @Prop({ default: false }) dialogButton!: boolean;
  @Prop({ default: false }) fullWidth!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) selected!: boolean;
  @Prop({ default: false }) mobileCollapse!: boolean;
  @Prop({ default: false }) mobileButton!: boolean;
  @Prop({ default: false }) iconOnly!: boolean;
  @Prop({ default: false }) shadow!: boolean;
  @Prop() tabindex!: Number;

  // DATA
  click: boolean = false;

  // COMPUTED
  get deanButtonClass() {
    let value = 'dean-button';
    if (this.groupButton) value += ` dean-button-group-item`;
    else if (this.dialogButton)
      value += ` dean-button-group-item dean-button-dialog`;
    else if (this.fullWidth) value += ` dean-button-full-width`;
    if (this.mobileButton) value += ` mobile-button`;
    return value;
  }

  get deanButtonLinkClass() {
    console.log(this.disabled)
    let value = 'dean-button-item';
    if (this.disabled) value += ` dean-button-theme-disabled`;
    if (this.selected) value += ` dean-button-theme-selected`;
    if (!this.selected) value += ` dean-button-theme-not-selected`;
    if (this.standard) value += ` dean-button-theme-standard`;
    else if (this.success) value += ` dean-button-theme-success`;
    else if (this.info) value += ` dean-button-theme-info`;
    else if (this.warning) value += ` dean-button-theme-warning`;
    else if (this.danger) value += ` dean-button-theme-danger`;
    else if (this.primary) value += ` dean-button-theme-primary`;
    else if (this.secondary) value += ` dean-button-theme-secondary`;
    else if (this.link) value += ` dean-button-theme-link`;
    else if (this.grey) value += ` dean-button-theme-grey`;
    else if (this.theme) {
      value += ` dean-button-theme-${this.theme}`;
    }
    else value += ` dean-button-theme-standard`;
    if (this.iconOnly) value += ` dean-button-icon-only`;
    if (this.shadow) value += ` shadow`;
    return value;
  }

  get mobileCollapseClass() {
    let value = '';
    if (this.mobileCollapse) value = `mobile-collapse`;
    return value;
  }
  // METHODS
  deanButtonClick() {
    if (!this.disabled || !this.selected) {
      this.$emit('dean-button-click', true);
    }
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN BUTTON
.dean-button {
  display: inline-block;

  .dean-button-item {
    @include display-flex();
    align-items: center;
    cursor: pointer;
    text-decoration: none;
    font-weight: 500;
    //text-transform: lowercase;
    margin: 0;
    border: 0;
    padding: 10px 30px 10px 30px;
    @include transition(all ease  0.8s);
    @include border-radius(10px);
    background: var(--color-light-shade-2, $color-light-shade-2);
    min-height: 40px;
    &:after {
      margin-left: 5px;
      content: ' \203A';
    }
    .button-icon {
      margin-right: 5px;
    }
    span {
      width: 100%;
    }
    &:hover {
      outline: none;
      background-position: left bottom;
      box-shadow: 0px 0px 10px 2px var(--color-secondary, $color-secondary);
    }
  }

  // STANDARD
  .dean-button-theme-standard {
    background: var(--color-light-shade-2, $color-light-shade-2);
    color: var(--color-link, $color-link);
    fill: var(--color-link, $color-link);
    &:hover {
      color: var(--color-link, $color-link);
      background: var(--color-light, $color-light);
    }
  }

  // SUCCESS
  .dean-button-theme-success {
    background: var(--color-light-shade-2, $color-light-shade-2);
    color: var(--color-info-success, $color-info-success);
    fill: var(--color-info-success, $color-info-success);
    &:hover {
      color: var(--color-info-success, $color-info-success);
      background: var(--color-info-success-bg, $color-info-success-bg);
    }
  }

  // INFO
  .dean-button-theme-info {
    background: var(--color-light-shade-2, $color-light-shade-2);
    color: var(--color-info-standard, $color-info-standard);
    fill: var(--color-info-standard, $color-info-standard);
    &:hover {
      color: var(--color-info-standard, $color-info-standard);
      background: var(--color-info-standard-bg, $color-info-standard-bg);
    }
  }

  // WARNING
  .dean-button-theme-warning {
    background: var(--color-light-shade-2, $color-light-shade-2);
    color: var(--color-info-warning, $color-info-warning);
    fill: var(--color-info-warning, $color-info-warning);
    &:focus,
    &:hover {
      color: var(--color-info-warning, $color-info-warning);
      background: var(--color-info-warning-bg, $color-info-warning-bg);
    }
  }

  // DANGER
  .dean-button-theme-danger {
    background: var(--color-light-shade-2, $color-light-shade-2);
    color: var(--color-info-danger, $color-info-danger);
    fill: var(--color-info-danger, $color-info-danger);
    &:hover {
      color: var(--color-info-danger, $color-info-danger);
      background: var(--color-info-danger-bg, $color-info-danger-bg);
    }
  }

  // PRIMARY
  .dean-button-theme-primary {
    background: var(--color-primary, $color-primary);
    color: white;
    fill: white;
    &:hover {
      color: white;
      background: var(--color-primary-shade-2, $color-primary-shade-2);
    }
  }

  // SECONDARY
  .dean-button-theme-secondary {
    background: var(--color-secondary, $color-secondary);
    color: white;
    fill: white;
    &:hover {
      color: white;
      background: var(--color-secondary-shade-2, $color-secondary-shade-2);
    }
  }

  // LINK
  .dean-button-theme-link {
    background: var(--color-link, $color-link);
    color: white;
    fill: white;
    &:hover {
      color: white;
      background: var(--color-link-shade-2, $color-link-shade-2);
    }
  }

  // GREY
  .dean-button-theme-grey {
    background: var(--color-light, $color-light);
    color: black;
    fill: black;
    &:hover {
      color: black;
      background: var(--color-dark-shade-4, $color-dark-shade-4);
    }
  }

   // DISABLED
  .dean-button-theme-disabled {
    background: var(--color-light-shade-4, $color-light-shade-4);
    color: var(--color-dark-shade-4, $color-dark-shade-4);
    fill: var(--color-dark-shade-4, $color-dark-shade-4);
    &:hover {
      background: var(--color-light-shade-4, $color-light-shade-4);
      color: var(--color-dark-shade-4, $color-dark-shade-4);
      cursor: not-allowed;
    }
  }

  // SELECTED
  .dean-button-theme-selected {
    position: relative;
    background: var(--color-info-success, $color-info-success);
    color: white;
    &:hover {
      background: var(--color-info-success, $color-info-success);
      color: white;
      cursor: default;
    }
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-image: linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.05) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.05) 50%,
      rgba(255, 255, 255, 0.05) 75%,
      transparent 75%,
      transparent
      );
      background-size: 25px 25px;
      animation: move 2s linear infinite;
    }
  }
}

// BUTTON GROUP
.dean-button-group-item {
  padding: 0px;
  &:first-of-type {
    border-right: 1px solid var(--color-light, $color-light);
  }
  &:nth-of-type(n) {
    border-right: 1px solid var(--color-light, $color-light);
  }
  &:last-of-type {
    border-right: 0;
  }
  .dean-button-item {
    @include border-radius(0px);
    border: 0;
    &:after {
      margin-left: 0px;
      content: '';
    }
    &:hover {
      outline: none;
      background-position: left bottom;
      box-shadow: none;
    }

  }
}

// FULL WIDTH
.dean-button-full-width {
  display: block;
  min-width: 100%;
  .dean-button-item {
    min-width: 100%;
  }
}

// DIALOG BUTTONS
.dean-button-dialog {
  -webkit-flex: 1; /* Safari 6.1+ */
  -ms-flex: 1; /* IE 10 */
  flex: 1;
  margin: 0;
  text-align: center;

  &:first-of-type {
    border-right: 1px solid var(--color-light-shade-2, $color-light-shade-2);
  }
  &:nth-of-type(n) {
    border-right: 1px solid var(--color-light-shade-2, $color-light-shade-2);
  }
  &:last-of-type {
    border-right: 0;
  }

  .dean-button-item {
    min-width: 100%;
    min-height: 100%;
    text-align: center;
    padding: 20px;
    &:after {
      margin-left: 5px;
      content: none;
    }
    &:hover {
      box-shadow: none;
    }
  }

  // DIALOG STANDARD
  .dean-button-theme-standard {
    background: white;
    fill: var(--color-dark-shade-2, $color-dark-shade-2);
    color: var(--color-dark-shade-2, $color-dark-shade-2);
  }

  // DIALOG SUCCESS
  .dean-button-theme-success {
    background: white;
    color: var(--color-info-success, $color-info-success);
    fill: var(--color-info-success, $color-info-success);
  }

  // DIALOG INFO
  .dean-button-theme-info {
    background: white;
    color: var(--color-info-standard, $color-info-standard);
    fill: var(--color-info-standard, $color-info-standard);
  }

  // DIALOG WARNING
  .dean-button-theme-warning {
    background: white;
    color: var(--color-info-warning, $color-info-warning);
    fill: var(--color-info-warning, $color-info-warning);
  }

  // DIALOG DANGER
  .dean-button-theme-danger {
    background: white;
    color: var(--color-info-danger, $color-info-danger);
  }

  // DIALOG PRIMARY
  .dean-button-theme-primary {
    background: white;
    color: var(--color-primary, $color-primary);
  }

  // DIALOG SECONDARY
  .dean-button-theme-secondary {
    background: white;
    color: var(--color-secondary, $color-secondary);
  }

  // GREY
  .dean-button-theme-grey {
    background: white;
    color: var(--color-dark-shade-4, $color-dark-shade-4);
  }

  // DISABLED
  .dean-button-theme-disabled {
    background: white;
    color: var(--color-dark-shade-4, $color-dark-shade-4);
    &:hover {
      background: white;
      color: var(--color-dark-shade-4, $color-dark-shade-4);
      cursor: not-allowed;
    }
  }
}
.mobile-collapse {
  @media #{$small-only} {
    display: none;
  }
}

.mobile-button {
  @media #{$medium} {
    display: none;
  }
}

.dean-button-icon-only {
  padding: 10px;
  span {
    display: none;
  }
}

.shadow {
  @include box-shadow(0px 3px 5px rgba(0, 0, 0, 0.075));
}
</style>
